import {
  VIEW_JSON_FILE,
  VIEW_JSON_FILE_FAILURE,
  VIEW_JSON_FILE_SUCCESS,
} from "../../Actions/types";

const initialState = {
  getLoader: false,
  getData: null,
  getError: false,
};
function viewJsonFileReducer(state = initialState, action) {
  switch (action.type) {
    case VIEW_JSON_FILE:
      return { ...state, getLoader: true };
    case VIEW_JSON_FILE_SUCCESS:
      return { ...state, getData: action?.payload, getLoader: false };
    case VIEW_JSON_FILE_FAILURE:
      return { ...state, getError: true, getLoader: false };

    default:
      return state;
  }
}

export default viewJsonFileReducer;
